document.addEventListener('DOMContentLoaded', function () {
  if (googleConsentManagerEnabled()) {
    setMarketingConsentState(true);
    return;
  }

  const cookieConsentBannerElement = document.querySelector('cookie-consent-banner');
  setMarketingConsentState(false);

  if (cookieConsentBannerElement) {
    cookieConsentBannerElement.availableCategories = [
      {
        description:
          'Enable you to navigate and use the basic functions and to store preferences.',
        key: 'technically_required',
        label: 'Technically necessary cookies',
        isMandatory: true
      },
      {
        description:
          'Enable us to determine how visitors interact with our service in order to improve the user experience.',
        key: 'analytics',
        label: 'Analysis cookies'
      },
      {
        description:
          'Enable us to offer and evaluate relevant content and interest-based advertising.',
        key: 'marketing',
        label: 'Marketing cookies'
      }
    ];
  }

  bindClick('#show-cookie-banner-link', function () {
    if (cookieConsentBannerElement) {
      cookieConsentBannerElement.classList.remove('hidden');
    }
    document.dispatchEvent(new Event('cookie_consent_show'));
  });

  bindClick('#show-cookie-banner-link-inline', function () {
    if (cookieConsentBannerElement) {
      cookieConsentBannerElement.classList.remove('hidden');
    }
    document.dispatchEvent(new Event('cookie_consent_show'));
  });

  bindClick('#show-cookie-banner-categories', function () {
    document.dispatchEvent(new Event('cookie_consent_details_show'));
  });
});

function bindClick(selector, callback) {
  const element = document.querySelector(selector);
  if (!element) return;

  element.addEventListener('click', function (event) {
    event.preventDefault();
    callback();
  });
}

// ad_storage	Enables storage (such as cookies) related to advertising.
// ad_user_data	Sets consent for sending user data related to advertising to Google.
// ad_personalization	Sets consent for personalized advertising.
// analytics_storage	Enables storage (such as cookies) related to analytics e.g. visit duration.
// In addition to the consent mode parameters, there are the following privacy parameters:
// Storage Type	Description
// functionality_storage	Enables storage that supports the functionality of the website or app e.g. language settings.
// personalization_storage	Enables storage related to personalization e.g. video recommendations
// security_storage	Enables storage related to security such as authentication functionality, fraud prevention, and other user protection.
// https://developers.google.com/tag-platform/security/guides/consent?hl=pl&consentmode=advanced#tag-manager_3


// COOKIE CONSENT: init user grants after interaction
function updateGrants(event) {
  const acceptedCategories = Array.isArray(event?.detail?.acceptedCategories) ? event.detail.acceptedCategories : [];
  const marketingGranted = acceptedCategories.includes("marketing");

  let consent = {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied'
  }

  if (acceptedCategories.includes("analytics")) {
    // console.log("Analytics accepted.");
    consent['analytics_storage'] = 'granted'
  }
  if (marketingGranted) {
    // console.log("Marketing accepted.");
    consent['ad_storage'] = 'granted'
    consent['ad_user_data'] = 'granted'
    consent['ad_personalization'] = 'granted'
  }

  setMarketingConsentState(marketingGranted);
  if (typeof gtag === 'undefined') return;

  gtag('consent', 'update', {
    'ad_storage': consent['ad_storage'],
    'ad_user_data': consent['ad_user_data'],
    'ad_personalization': consent['ad_personalization'],
    'analytics_storage': consent['analytics_storage']
  });
}

function setMarketingConsentState(granted) {
  if (document.body) {
    document.body.dataset.lpMarketingConsent = granted ? 'granted' : 'denied';
  }

  window.dispatchEvent(new CustomEvent('lp_marketing_consent_changed', {
    detail: {
      granted: !!granted
    }
  }));
}

function googleConsentManagerEnabled() {
  return document.body?.dataset?.lpConsentManager === 'google';
}

window.addEventListener('cookie_consent_preferences_restored', updateGrants);
window.addEventListener('cookie_consent_preferences_updated', updateGrants);
